import { render } from "./TrashBtn.vue?vue&type=template&id=41fc7cb4&scoped=true"
import script from "./TrashBtn.vue?vue&type=script&lang=js"
export * from "./TrashBtn.vue?vue&type=script&lang=js"

import "./TrashBtn.vue?vue&type=style&index=0&id=41fc7cb4&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41fc7cb4"]])

export default __exports__